import { render, staticRenderFns } from "./scan_import.vue?vue&type=template&id=5836acdd&scoped=true&"
import script from "./scan_import.vue?vue&type=script&lang=ts&"
export * from "./scan_import.vue?vue&type=script&lang=ts&"
import style0 from "./scan_import.vue?vue&type=style&index=0&id=5836acdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836acdd",
  null
  
)

export default component.exports